export default "__VITE_ASSET__738f4708__"